import type { Profile } from '@/lib/queries/profiles'

/**
 * Onboarding steps in order. Each is shown until its answer exists, so a
 * step added later also reaches people who signed up before it.
 */
const ONBOARDING_STEPS = [
  { id: 'name', isNeeded: (profile: Profile) => !profile.full_name?.trim() },
] as const

export type OnboardingStep = (typeof ONBOARDING_STEPS)[number]['id']

export function nextOnboardingStep(
  profile: Profile
): OnboardingStep | undefined {
  return ONBOARDING_STEPS.find((step) => step.isNeeded(profile))?.id
}
